import { render, staticRenderFns } from "./HelpIconology.vue?vue&type=template&id=0d887548&"
import script from "./HelpIconology.vue?vue&type=script&lang=ts&"
export * from "./HelpIconology.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports